import { takeLatest } from 'redux-saga/effects';
import { FETCH_CALENDAR_DETAILS_REQUEST } from '../../redux/modules/dashboard/dashboard-actions';
import fetchCalendarWorkerSaga from './dashboardWorkerSaga';

export default function* fetchCalendarDetailSaga() {
    yield takeLatest(FETCH_CALENDAR_DETAILS_REQUEST, fetchCalendarWorkerSaga);
}
